var _a;
export var PIXEL = 'px';
export var POINT = 'pt';
export var DENSITY_INDEPENDENT_PIXEL = 'dp';
export var SCALE_INDEPENDENT_PIXEL = 'sp';
export var PERCENTAGE = '%';
export var LABELS = (_a = {},
    _a[PIXEL] = 'Pixels',
    _a[POINT] = 'Points',
    _a[DENSITY_INDEPENDENT_PIXEL] = 'DPI',
    _a);
